export default "__VITE_ASSET__CeH35TTe__"